export default "__VITE_ASSET__i1AoY3wY__"